import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from 'src/app/core/constants/routes';
import { VOUCHER_TAB_MENU_ITEMS } from 'src/app/core/constants/menuItems';
import { DialogService } from 'src/app/core/services/dialog.service';

@Component({
  selector: 'app-voucher-dialog',
  templateUrl: './voucher-dialog.component.html',
  styleUrl: './voucher-dialog.component.scss'
})
export class VoucherDialogComponent {
  constructor(
    protected dialogService: DialogService,
    private router: Router
  ) {}

  navigateToMyVouchersTab(): void {
    this.router.navigate(['/', ROUTES.MAX_VOUCHERS], {
      queryParams: {
        module: ROUTES.MAX_VOUCHERS_MY_VOUCHERS,
        filter: VOUCHER_TAB_MENU_ITEMS[0].content
      }
    });
    this.dialogService.closeDialog();
  }
}
